export default __webpack_public_path__ + "static/media/logoHeader.dfed6d98.png";